import { render, staticRenderFns } from "./AudioButton.vue?vue&type=template&id=2b0e6cd0&scoped=true&"
import script from "./AudioButton.vue?vue&type=script&lang=js&"
export * from "./AudioButton.vue?vue&type=script&lang=js&"
import style0 from "./AudioButton.vue?vue&type=style&index=0&id=2b0e6cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e6cd0",
  null
  
)

export default component.exports